import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="trial-licenses"
export default class extends Controller {

  static targets = ["submit", "checkbox"]

  connect() {
    if (this.hasSubmitTarget) {
      const recaptchaElement = document.querySelector(".g-recaptcha");
      this.recaptchaCheck = !recaptchaElement;

      this.toggleSubmitButton();
      window.addEventListener("recaptcha:success", this.updateRecaptchaCheck.bind(this));
    }
  }

  disconnect() {
    if (this.hasSubmitTarget) {
      window.removeEventListener("recaptcha:success", this.updateRecaptchaCheck.bind(this));
    }

    super.disconnect();
  }

  updateRecaptchaCheck() {
    this.recaptchaCheck = true;

    this.toggleSubmitButton();
  }

  toggleSubmitButton() {
    const allChecked = this.checkboxTargets.every(checkbox => checkbox.checked) && this.recaptchaCheck
    this.submitTarget.disabled = !allChecked
  }

  check() {
    this.toggleSubmitButton()
  }

  reviewLicense(event) {
    event.preventDefault();

    const url = "/sam4h_trials/review";
    const csrfToken = document.querySelector('meta[name="csrf-token"]').content;

    $.ajax({
      url: url,
      method: 'POST',
      data: $('#trial-license-form').serialize(),
      dataType: 'script',
      headers: {
        'X-CSRF-Token': csrfToken
      },
    });
  }

  createLicense(event) {
    event.preventDefault();

    const form = $('#trial-license-form');
    const csrfToken = document.querySelector('meta[name="csrf-token"]').content;

    $.ajax({
      url: form.action,
      method: 'POST',
      data: form.serialize(),
      headers: {
        'X-CSRF-Token': csrfToken
      },
    });
  }
}
